import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

const users = {
  data: {
    users: [
      {
        id: "85dc9562-58d3-8738-9735-ca2139a83809",
        avatar: "",
        name: "Rita Chen",
        email: "wqeqwe2@mail.com",
        mspRoleName: "Viewer",
        mspRoleId: 3,
        orgAccesses: [
          {
            orgName: "org1",
            orgId: "9f0a2cce-45b8-46a4-b4cf-7e6eaa7d4e0f",
            orgRoleName: "Viewer",
            orgRoleId: 7,
          },
          {
            orgName: "org2",
            orgId: "1d37f278-6b7a-4b65-88ab-bbb21e03fae1",
            orgRoleName: "Admin",
            orgRoleId: 6,
          },
        ],
        status: "inactive",
        timeOfAuth: 1736356148,
        lastLoginTime: 1736312346,
      },
      {
        id: "aa997107-4cbc-db83-53e2-4433514aa96a",
        avatar: "",
        email: "user003@mail.com",
        mspRoleName: "Super Admin",
        mspRoleId: 1,
        orgAccesses: [
          {
            orgName: "org2",
            orgId: "1d37f278-6b7a-4b65-88ab-bbb21e03fae1",
            orgRoleName: "Super Admin",
            orgRoleId: 5,
          },
        ],
        status: "active",
        timeOfAuth: 1736399854,
        lastLoginTime: 1736367841,
      },
      {
        id: "1abb1a8d-cd93-9471-08ca-528b9c316ca8",
        avatar: "",
        name: "User 005 Admin",
        email: "fgsfsf333@mail.com",
        mspRoleName: "Viewer",
        mspRoleId: 3,
        orgAccesses: [
          {
            orgName: "org2",
            orgId: "1d37f278-6b7a-4b65-88ab-bbb21e03fae1",
            orgRoleName: "Admin",
            orgRoleId: 6,
          },
        ],
        status: "active",
        timeOfAuth: 1736354321,
        lastLoginTime: 1736356723,
      },
      {
        id: "43788ba6-3d14-3e1d-740d-56792c94258a",
        avatar: "",
        name: "User 006 Admin",
        email: "12321dfa@mail.com",
        mspRoleName: "Admin",
        mspRoleId: 2,
        orgAccesses: [],
        status: "active",
        timeOfAuth: 1736312345,
        lastLoginTime: 1736356143,
      },
    ],
  },
};

const invitations = {
  data: {
    invitations: [
      {
        invitationId: "ad93cec4-3444-8480-e65d-038b2db22c67",
        email: "qqqqweqewqewqe123123@mail.com",
        mspRoleName: "Viewer",
        mspRoleId: 3,
        orgAccesses: [
          {
            orgName: "org2",
            orgId: "1d37f278-6b7a-4b65-88ab-bbb21e03fae1",
            orgRoleName: "Admin",
            orgRoleId: 6,
          },
        ],
        timeOfInvitation: 1747892552,
      },
      {
        invitationId: "ce09d7fd-debb-dad4-2452-c606fdc1b807",
        email: "rfsdf12@mail.com",
        mspRoleName: "Admin",
        mspRoleId: 2,
        orgAccesses: [],
        timeOfInvitation: 1746859463,
      },
    ],
  },
};

const roleMap = {
  1: "Super Admin",
  2: "Admin",
  3: "Viewer",
};

const orgRoleMap = {
  5: "Super Admin",
  6: "Admin",
  7: "Viewer",
};

const orgMap = {
  "9f0a2cce-45b8-46a4-b4cf-7e6eaa7d4e0f": "org1",
  "1d37f278-6b7a-4b65-88ab-bbb21e03fae1": "org2",
};

const initialState = {
  users,
  invitations,
};

export const mspUserManagementSlice = createSlice({
  name: "mspUserManagement",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.users.data = action.payload;
    },
    setInvitationUser: (state, action) => {
      state.invitations.data = action.payload;
    },
    addInvitationUser: (state, action) => {
      if (!state.invitations.data.invitations) {
        state.invitations.data.invitations = [];
      }

      const payload = action.payload;

      const newInvitation = {
        ...payload,
        invitationId: uuidv4(),
        timeOfInvitation: Math.floor(Date.now() / 1000),
        mspRoleName: roleMap[payload.mspRoleId] || "Viewer",
      };

      state.invitations.data.invitations.push(newInvitation);
    },
    removeUser: (state, action) => {
      const userId = action.payload;
      state.users.data.users = state.users.data.users.filter(
        (user) => user.id !== userId
      );
    },
    removeInvitation: (state, action) => {
      const invitationId = action.payload;
      state.invitations.data.invitations =
        state.invitations.data.invitations.filter(
          (inv) => inv.invitationId !== invitationId
        );
    },
    updateUser: (state, action) => {
      const { userId, updates } = action.payload;
      const userIndex = state.users.data.users.findIndex(
        (user) => user.id === userId
      );

      if (userIndex !== -1) {
        let updatedUser = {
          ...state.users.data.users[userIndex],
          ...updates,
        };

        if (updates.mspRoleId !== undefined) {
          updatedUser.mspRoleName = roleMap[updates.mspRoleId] || "Viewer";
        }
        if (updates.orgAccesses) {
          updatedUser.orgAccesses = updates.orgAccesses.map((org) => {
            let orgId = org.orgId;

            if (orgId.includes("_ID")) {
              const baseName = orgId.replace("_ID", "");
              const foundUUID = Object.keys(orgMap).find(
                (uuid) => orgMap[uuid] === baseName
              );
              if (foundUUID) {
                orgId = foundUUID;
              }
            }

            return {
              ...org,
              orgId,
              orgName: orgMap[orgId],
              orgRoleName: orgRoleMap[org.orgRoleId],
            };
          });
        }

        state.users.data.users[userIndex] = updatedUser;
      }
    },
    updateInvitation: (state, action) => {
      const { invitationId, updates } = action.payload;
      const invitationIndex = state.invitations.data.invitations.findIndex(
        (inv) => inv.invitationId === invitationId
      );

      if (invitationIndex !== -1) {
        const prevData = state.invitations.data.invitations[invitationIndex];

        let updatedInvitation = {
          ...prevData,
          ...updates,
        };

        if (updates.mspRoleId !== undefined) {
          updatedInvitation.mspRoleName =
            roleMap[updates.mspRoleId] || "Viewer";
        }

        if (updates.orgAccesses) {
          updatedInvitation.orgAccesses = updates.orgAccesses.map((org) => {
            let orgId = org.orgId;

            if (orgId.includes("_ID")) {
              const baseName = orgId.replace("_ID", "");
              const foundUUID = Object.keys(orgMap).find(
                (uuid) => orgMap[uuid] === baseName
              );
              if (foundUUID) {
                orgId = foundUUID;
              }
            }

            return {
              ...org,
              orgId,
              orgName: orgMap[orgId] || "Unknown Org",
              orgRoleName: orgRoleMap[org.orgRoleId] || "Viewer",
            };
          });
        }

        state.invitations.data.invitations[invitationIndex] = updatedInvitation;
      }
    },
  },
});

export const {
  setUser,
  setInvitationUser,
  addInvitationUser,
  removeUser,
  removeInvitation,
  updateUser,
  updateInvitation,
} = mspUserManagementSlice.actions;

export default mspUserManagementSlice.reducer;
